export const getIsPreparingDownloadAllAttachments = (state) => {
  return !!state.preparingDownloadAllAttachments;
};
